import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import {
    Button,
    Card,
    CardContent, Container,
    Dialog,
    DialogActions,
    DialogContent, DialogContentText,
    DialogTitle,
    Fade, FormControl,
    IconButton,
    Stack,
    Table,
    TableBody, TableCell, TableContainer,
    TableHead, TableRow,
    TextField,
    Typography,
    Divider
} from "@mui/material";
import { useStoreState } from "pullstate";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import BackdropLoader from '../../components/BackdropLoader.jsx';
import SearchField from "../../components/SearchField.jsx";
import globalStyles from '../../components/styles/css/GlobalStyles.module.css';
import { AppStore } from "../../stores/AppStore.js";
import { api } from '../../utils/apiFunctions';
import useDebouncedValue from '../../utils/useDebouncedValue.js';
import { getDepartments } from '../../utils/getData.js';

const Departments = () => {
    const openAlert = useStoreState(AppStore, s => s.snackbar.openAlert);
	const loading = useStoreState(AppStore, s => s.loading)
	const departments = useStoreState(AppStore, s => s.departments)
    const searchText = useStoreState(AppStore, s => s.searchText);
    const debouncedSearchText = useDebouncedValue(searchText, 100);
    const googleToken = useStoreState(AppStore, s => s.googleToken);
    const [department, setDepartment] = useState([])
    const [departmentForms, setDepartmentForms] = useState(false)
    const [focusedRow, setFocusedRow] = useState(null);
    const [editingRowId, setEditingRowId] = useState(null);
    const [tempTextField, setTempTextField] = useState('')
    const [iconsVisible, setIconsVisible] = useState(false)
    const [openDeleteDepartment, setOpenDeleteDepartment] = useState(false)
    const [departmentToDelete, setDepartmentToDelete] = useState({
        department: '',
        id: ''
    })

    useEffect(() => {
        if (!departments) getDepartments();
    }, [departments]);

    const departmentsFiltered = useMemo(() => {
        const q = debouncedSearchText.toLowerCase();
        return (departments ?? []).filter(department => department.department.toLowerCase().includes(q));
    }, [departments, debouncedSearchText]);

    const saveNewDepartment = async (newDepartment) => {

        AppStore.update((s) => {s.loading = true})

        try {
            api.post(`/departments`, { department: newDepartment }, {
                headers: {
                    Authorization: `Bearer ${googleToken}`,
                },
            }).then(async res => {
                if (res.status === 200) {
                    openAlert('Department created sucessful', 'success')
                    AppStore.update((s) => {s.loading = false})
                    getDepartments()
                }
            })
        } catch (error) {
            openAlert(error.message, 'error')
            console.log(error)
        }

        setEditingRowId(null)
    };

    const deleteDepartment = useCallback(async () => {
        setOpenDeleteDepartment(false)
        AppStore.update((s) => {s.loading = true})
        const id = departmentToDelete.id

        try {
            api.delete(`/departments/${id}`, {
                headers: {
                    Authorization: `Bearer ${googleToken}`,
                },
            }).then(async res => {
                openAlert(res.data.message, res.data.status === 200 ? 'success' : 'error')
                AppStore.update((s) => {s.loading = false})
                getDepartments()

            })
        } catch (error) {
            openAlert(error.message, 'error')
            console.log(error)
        }

        setEditingRowId(null)
    })

    const updateDepartment = async (id, newDepartment) => {
        AppStore.update((s) => {s.loading = true})
        try {
            api.put(`/departments/${id}`, { department: newDepartment }, {
                headers: {
                    Authorization: `Bearer ${googleToken}`,
                },
            }).then(async res => {
                if (res.status === 200) {
                    openAlert('Department updated sucessful', 'success')
                    AppStore.update((s) => {s.loading = false})
                    setDepartment(newDepartment)
                }
            })
        } catch (error) {
            openAlert(error.message, 'error')
            console.log(error)
        }

        setEditingRowId(null)
    };

    const handleClose = () => {
        setOpenSnackbar(false)
    }

    return (
        <Container maxWidth="xl" sx={{ mt: 10 }}>
            <Card className={globalStyles.card} >
            <Typography sx={{ paddingTop: '20px' }} variant='h5' align='center'>Departments</Typography>
                <BackdropLoader openBackdrop={loading} />
                <CardContent sx={{paddingTop: 0}}>
                    <Stack  marginBottom="16px" direction="row" alignItems="center" justifyContent='space-between'>
                        <SearchField />
                        <Button
                            onClick={() => {
                                setEditingRowId(null)
                                setDepartmentForms(!departmentForms)
                            }}
                            variant="text"
                            startIcon={<AddIcon />}
                        >Add New</Button>
                    </Stack>
                    {departmentForms && (
                        <Fade in={departmentForms} timeout={500}>
                            <Card sx={{ boxShadow: 3, marginBottom: 2 }}>
                                <CardContent>
                                    <FormControl fullWidth sx={{ m: 0 }} >
                                        <Stack direction="row" spacing={1}>
                                            <TextField
                                                sx={{ width: '30%' }}
                                                size='small'
                                                id="outlined-basic"
                                                label="Department Name"
                                                variant="outlined"
                                                onChange={(e) => setDepartment(e.target.value)}
                                            />
                                            <Button
                                                onClick={() => {
                                                    setDepartmentForms(false)
                                                    saveNewDepartment(department)
                                                }}
                                                variant="outlined"
                                                sx={{ width: '10%' }}
                                            >Save</Button>
                                        </Stack>
                                    </FormControl>
                                </CardContent>
                            </Card>
                        </Fade>
                    )}
                    <TableContainer sx={{ boxShadow: 3 }} className={globalStyles.tableContainer}>
                    
                        <Table stickyHeader className={globalStyles.tableStyles}>

                            <TableBody>
                                {departmentsFiltered.map(department => (
                                    <TableRow
                                        hover
                                        sx={{ height: 70 }}
                                        className={globalStyles.cursor_pointer}
                                        key={department.id}
                                    >
                                        <TableCell sx={{ width: 500 }}>
                                            {editingRowId === department.id ? (
                                                <TextField
                                                    sx={{ width: '60%' }}
                                                    size='small'
                                                    value={tempTextField}
                                                    onChange={(e) => setTempTextField(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            updateDepartment(department.id, tempTextField);
                                                        }
                                                    }}
                                                    autoFocus
                                                />
                                            ) : (
                                                department.department
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                            {(editingRowId !== department.id) && (
                                                <Stack visibility={iconsVisible} direction='row' spacing={1}>
                                                    <IconButton
                                                        onClick={(event) => {
                                                            setDepartmentForms(false)
                                                            setEditingRowId(department.id);
                                                            setTempTextField(department.department);
                                                        }}
                                                        size="small" >
                                                        <EditIcon />
                                                    </IconButton>
                                                    <IconButton
                                                        onClick={() => {
                                                            setOpenDeleteDepartment(true)
                                                            setDepartmentToDelete({
                                                                department: department.department,
                                                                id: department.id
                                                            })
                                                        }}
                                                        size="small"
                                                        color="teal">
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Stack>
                                            )}
                                            {editingRowId === department.id && (
                                                <Stack direction='row'>
                                                    <IconButton
                                                        onClick={() => {
                                                            updateDepartment(department.id, tempTextField)
                                                        }}
                                                        size="small"
                                                        color="teal">
                                                        <SaveIcon />
                                                    </IconButton>
                                                    <IconButton onClick={() => setEditingRowId(null)}>
                                                        <CloseIcon />
                                                    </IconButton>
                                                </Stack>
                                            )}
                                        </TableCell>
                                    </TableRow>

                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>
            <Dialog
                open={openDeleteDepartment}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"WARNING!"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        You are about to delete {departmentToDelete.department}.
                        Are you sure you want to do this?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDeleteDepartment(false)}>Cancel</Button>
                    <Button onClick={deleteDepartment} >Confirm</Button>
                </DialogActions>
            </Dialog>
        </Container>
    )
}

export default Departments